import {buildCreateRequest} from '../../config/redux-list/requests';
import {getCreateProject} from '../reducers/state';
import {CREATE_PROJECT_PREFIX} from './state';
import {logger} from './logger';


/** @type {ReduxRequest} */
export const createProjectRequest = buildCreateRequest({
  prefix: CREATE_PROJECT_PREFIX,
  getState: getCreateProject,
  path: 'projects',
  logger,
});



// WEBPACK FOOTER //
// ./src/js/projects/redux/createProject.js